var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleInstances({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_832_540)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 0.999924L21 8",
    stroke: "#F2962E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 20C23 20.5555 22.5614 21.2908 21.3327 21.9461C20.147 22.5784 18.4402 23 16.5 23C14.5598 23 12.853 22.5784 11.6673 21.9461C10.4386 21.2908 10 20.5555 10 20C10 19.4445 10.4386 18.7092 11.6673 18.0539C12.853 17.4216 14.5598 17 16.5 17C18.4402 17 20.147 17.4216 21.3327 18.0539C22.5614 18.7092 23 19.4445 23 20Z",
    stroke: "#F2962E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0H14V7C14 7.55228 14.4477 8 15 8H22V14H10C8.89543 14 8 14.8954 8 16V24H3C2.44772 24 2 23.5523 2 23V1C2 0.447716 2.44772 0 3 0Z",
    fill: "#F2962E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.5,
    cy: 20,
    rx: 2.5,
    ry: 2,
    fill: "#F2962E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1V8C13 8.55228 13.4477 9 14 9H21L13 1Z",
    fill: "#F2962E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_832_540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleInstances);
export default __webpack_public_path__ + "static/media/multiple-instances.919233a91819e40c2fda75e3d055338d.svg";
export { ForwardRef as ReactComponent };